import { MOCK_CHAT } from "./constants";
import { DEFAULT_SUPPORTED_LOCALE, SUPPORTED_LOCALES } from "@whatslly/commons/locale/constants";

const pod = import.meta.env.VITE_API_DEFAULT_POD?.toString() || "us1";

export const getPod = () => pod;

export const isTestingEnv = () =>
  document.location.origin === MOCK_CHAT ||
  (import.meta.env.VITE_MOCK_MESSAGING_URL && document.location.origin === import.meta.env.VITE_MOCK_MESSAGING_URL);

export const getSupportedDayjsLocale = (locale = navigator.language.toLowerCase()) => {
  if (SUPPORTED_LOCALES.includes(locale)) return locale;

  const firstTwoLetters = locale.split("-")[0];
  if (SUPPORTED_LOCALES.includes(firstTwoLetters)) return firstTwoLetters;

  return DEFAULT_SUPPORTED_LOCALE;
};
